import React from "react";
import { useParams } from "react-router-dom";

import {
  Page,
  PageContent,
  Logo,
  Success,
  LogoTitle,
  MainContent,
  ButtonsArea,
  SignInButton,
} from "./styles";

function PaymentFeedback({ history }) {
  const { status } = useParams();

  function handleGoToSignIn() {
    window.open("http://www.topusperformance.com.br/aulas/#/login");
    return null;
  }

  function renderFeedback() {
    if (status !== "completo") {
      return (
        <MainContent>
          <h1>
            Aguardando
            <br />
            pagamento
          </h1>
          <p>
            Você ainda realizar o pagamento através do link fornecido via e-mail
            ou acessando sua conta
          </p>
          <ButtonsArea>
            <SignInButton onClick={handleGoToSignIn}>
              Acessar sua conta
            </SignInButton>
          </ButtonsArea>
        </MainContent>
      );
    }

    return (
      <MainContent>
        <Success />
        <h1>
          Pagamento
          <br />
          confirmado!
        </h1>
        <p>
          Tudo certo pra você já começar a assistir suas aulas! Clique no link
          abaixo para acessar sua conta.
        </p>
        <ButtonsArea>
          <SignInButton onClick={handleGoToSignIn}>Acessar aulas</SignInButton>
        </ButtonsArea>
      </MainContent>
    );
  }

  return (
    <Page>
      <PageContent>
        <Logo />
        <LogoTitle>Treinamentos Online</LogoTitle>
        {renderFeedback()}
      </PageContent>
    </Page>
  );
}

export default PaymentFeedback;
